export const roleSelector = (state) => state.role;